var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('v-sheet', {
    attrs: {
      "color": "transparent"
    }
  }, [_vm.detect == 'pc' ? _c('div', {
    staticClass: "tit-wrap tit-wrap--unberline"
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("마이페이지")])]) : _vm._e(), _c('mypage-dashboard-head', {
    staticClass: "mb-2 mb-md-12",
    class: {
      'mt-n7': _vm.detect == 'mobile'
    }
  }), _vm.detect == 'pc' ? _c('mypage-dashboard-cash', {
    staticClass: "mb-2 mb-md-12"
  }) : _vm._e(), _vm.detect == 'mobile' ? _c('mypage-dashboard-tool', {
    staticClass: "mb-2 mb-md-12"
  }) : _vm._e(), _c('mypage-dashboard-menu')], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }